import { useContext, useEffect, useState } from 'react'

import centralsIcon from '../../../assets/icons/central.svg'

import { SL_Button } from '../../../components/buttons/Button'
import { CentralOnCentralSection } from './CentralOnCentralSection'
import { Search } from './Search'

import { displayMessage } from '../../../helpers/messages'

export const CentralsSection = ({ centrals = [], onManageCentrals, userAllowedToManage }) => {
    const [search, setSearch] = useState('')
    const [showedCentrals, setShowedCentrals] = useState(centrals)

    useEffect(() => {
        setShowedCentrals(centrals)
    }, [centrals])

    useEffect(() => {
        if (!search || search == '') {
            setShowedCentrals(centrals)
        } else {
            const newShowedCentrals = [...centrals].filter((central) => {
                const { id, name } = central
                return `${id}`.includes(search) || name.toLowerCase().includes(search.toLowerCase())
            })

            setShowedCentrals(newShowedCentrals)
        }
    }, [search])

    return (
        <div className="settings-modal-configs-central-section">
            <div className={`flex justify-between mb-2 settings-modal-configs-central-section-tile-div flex-wrap`}>
                <span className="text-white settings-modal-configs-central-section-tile"> {displayMessage('CENTRALS')}</span>
                {userAllowedToManage && (
                    <SL_Button type="default" className="bg-white/10 hover:bg-white/20 rounded settings-modal--button text-white flex justify-center items-center" onClick={() => onManageCentrals()}>
                        <span className="text-medium">{displayMessage('MANAGE_CENTRALS')}</span>
                    </SL_Button>
                )}
            </div>

            <Search placeholder={displayMessage('TO_SEARCH_CENTRALS')} setText={setSearch} text={search} margin={true} />

            <div className="settings-modal-configs-central-section-centrals ">
                {showedCentrals.map((central) => (
                    <CentralOnCentralSection key={central.id} central={central} />
                ))}
            </div>
        </div>
    )
}
